import { render, staticRenderFns } from "./disease_sel.vue?vue&type=template&id=7e792e5c&scoped=true"
import script from "./disease_sel.vue?vue&type=script&lang=js"
export * from "./disease_sel.vue?vue&type=script&lang=js"
import style0 from "./disease_sel.vue?vue&type=style&index=0&id=7e792e5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e792e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e792e5c')) {
      api.createRecord('7e792e5c', component.options)
    } else {
      api.reload('7e792e5c', component.options)
    }
    module.hot.accept("./disease_sel.vue?vue&type=template&id=7e792e5c&scoped=true", function () {
      api.rerender('7e792e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/disease_sel.vue"
export default component.exports